export const isMacPlatform = (): boolean =>
  typeof navigator !== 'undefined' &&
  navigator.platform.toLowerCase().includes('mac');

export const getSearchHotkeyLabel = (): string =>
  isMacPlatform() ? '⌘+K' : 'Ctrl+K';
